<template>
  <div class="text-center">
    <v-dialog
      v-model="curVisible"
      width="500"
    >
      <v-card>
        <v-card-title :class="headColor">
          {{title}}
        </v-card-title>

        <v-card-text>
          {{content}}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="curVisible = false"
          >
            确定
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    headColor: {
      type: String, // grey、primary、success、warning、error
      default: 'grey'
    },
    title: {
      type: String,
      default: '提示'
    },
    content: {
      type: String,
      default: ''
    }
  },
  computed: {
    curVisible: {
      get() {
        return this.visible
      },
      set(val) {
        var that = this
        that.$emit('update:visible', val)
        if (!val) {
          that.$emit('closed')
        }
      }
    }
  },
  data() {
    return {
    }
  },
  methods: {
  }
}
</script>
